import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortfolioComponent } from '../../pages/portfolio/portfolio.component';

const routes: Routes = [
  { path: '', component: PortfolioComponent },
  { path: 'weddings', redirectTo: 'wedding', pathMatch: 'full' },
  { path: 'portraits', redirectTo: 'wedding', pathMatch: 'full' },
  { path: 'events', redirectTo: 'wedding', pathMatch: 'full' },
  { path: 'fashion', redirectTo: 'wedding', pathMatch: 'full' },
  { path: 'travel', redirectTo: 'wedding', pathMatch: 'full' },
  { path: ':category', component: PortfolioComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PortfolioRoutingModule { }
